import { useState } from 'react'
import { X, Download, Loader2 } from 'lucide-react'
import type { AppReleaseDto } from '@familynest/shared'
import { downloadAndInstall, formatSize } from '../lib/appUpdate'
import { Button, useBackdropClose } from './ui'

/** Update-Hinweis (ADR-051): zeigt die neue Version + Notizen, bietet Download/Installation. */
export function UpdateDialog({ release, onClose }: { release: AppReleaseDto; onClose: () => void }): React.JSX.Element {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const backdrop = useBackdropClose(onClose)

  async function install(): Promise<void> {
    setBusy(true)
    setError(null)
    try {
      await downloadAndInstall(release)
    } catch {
      setError('Download fehlgeschlagen. Bitte später erneut versuchen.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 p-0 sm:items-center sm:p-4" {...backdrop}>
      <div className="w-full max-w-sm rounded-t-2xl border p-5 sm:rounded-2xl" style={{ backgroundColor: 'var(--color-card)', borderColor: 'var(--color-line)', paddingBottom: 'calc(1.25rem + env(safe-area-inset-bottom))' }} onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-semibold" style={{ color: 'var(--color-ink)' }}>🚀 Neue Version {release.versionName}</h2>
          <button onClick={onClose} aria-label="Schließen" className="rounded-lg p-1 hover:bg-black/5"><X className="size-5" style={{ color: 'var(--color-muted)' }} /></button>
        </div>
        {release.notes && <p className="mb-3 whitespace-pre-wrap text-sm" style={{ color: 'var(--color-ink)' }}>{release.notes}</p>}
        <p className="mb-4 text-xs" style={{ color: 'var(--color-muted)' }}>Größe: {formatSize(release.sizeBytes)} · Android. Nach dem Download die Installation bestätigen (ggf. einmalig „Unbekannte Apps installieren" erlauben).</p>
        {error && <p className="mb-2 text-sm" style={{ color: 'var(--color-danger)' }}>{error}</p>}
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={busy}>Später</Button>
          <Button onClick={install} disabled={busy}>{busy ? <Loader2 className="size-4 animate-spin" /> : <Download className="size-4" />} Herunterladen &amp; installieren</Button>
        </div>
      </div>
    </div>
  )
}
